module.exports = __webpack_public_path__ + "static/media/bbc.c1876613.png";